import React, { useState } from "react";
import { subscribeNewsletter } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    try {
      await subscribeNewsletter(email, "landing");
      setSubmitted(true);
      setEmail("");
      toast.success("Welcome to the loom. We'll be in touch.");
    } catch (err) {
      const msg =
        err?.response?.data?.detail?.[0]?.msg ||
        err?.response?.data?.detail ||
        "Something went wrong. Please try again.";
      toast.error(typeof msg === "string" ? msg : "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="newsletter"
      data-testid="newsletter-section"
      className="relative py-24 md:py-40"
    >
      <div className="mx-auto max-w-4xl px-6 md:px-10">
        <div className="text-center">
          <p className="eyebrow">The Dispatch</p>
          <h2
            data-testid="newsletter-heading"
            className="font-serif-display mt-4 text-4xl leading-tight text-[#F2EFEB] sm:text-5xl"
          >
            Word from the <em className="italic text-[#C9A87C]">loom.</em>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-[#A39D95]">
            Playtest calls, launch dates, behind-the-loom notes on God Complex
            and Fatewoven. Roughly monthly. No spam, ever.
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          data-testid="newsletter-form"
          noValidate
          className="mx-auto mt-14 max-w-xl"
        >
          <div className="flex items-end gap-4">
            <div className="flex-1">
              <label
                htmlFor="newsletter-email"
                className="block text-[10px] uppercase tracking-[0.32em] text-[#6E6A64]"
              >
                Email
              </label>
              <input
                id="newsletter-email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@somewhere.realm"
                data-testid="newsletter-email-input"
                className="thread-input mt-2"
                disabled={loading}
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="newsletter-submit"
              className="btn-primary !px-5 !py-3 disabled:opacity-50"
              aria-label="Subscribe"
            >
              {loading ? "Weaving…" : "Subscribe"}
              {!loading && <ArrowRight className="h-4 w-4" />}
            </button>
          </div>

          {submitted && (
            <p
              data-testid="newsletter-success"
              className="mt-6 text-center text-sm text-emerald-300"
            >
              You&apos;re on the list. Watch for the first dispatch.
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
